import fetch from 'auth/FetchInterceptor'
import {X_API_KEY} from "../configs/AppConfig";

const CalonMhsService = {}

CalonMhsService.getDataRiwayatStudi = function (token,id) {
    //console.log(id_peserta_didik);
    return fetch({
        url: '/transaksi/riwayatstudi',
        method: 'get',
        params: {
            "access_token":token,
            id
        },
        headers:{
            "x-api-key":X_API_KEY
        }
    })
}

CalonMhsService.getDataByUser = function (token,id_user_daftar) {

    return fetch({
        url: '/transaksi/pendaftarbyuser',
        method: 'get',
        params: {
            "access_token":token,
            id_user_daftar
        },
        headers:{
            "x-api-key":X_API_KEY
        }
    })
}


export default CalonMhsService;
